const updateRow = ({ object, key, items }) => {
  const {
    year,
    resourceOrigin,
    object: objectDetail,
    value,
    regions,
    stageName,
  } = object;

  const regionName = regions.map(
    region => `${region.city} - ${region.stateAbbrev}`
  ).join(', ');

  return items.map(item =>
    item.id === key ? { ...item, year, resourceOrigin, objectDetail, value, stageName, regionName } : item
  );
}

export default updateRow;
